import { render, staticRenderFns } from "./SkeletonShopCategory.vue?vue&type=template&id=43243422&"
import script from "./SkeletonShopCategory.vue?vue&type=script&lang=js&"
export * from "./SkeletonShopCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports